class ProductGrid extends HTMLElement {
  constructor() {
    super();

    this.loading = false;
    this.gridOuter = null;
    
    this.bindHandleScroll = this.handleScroll.bind(this);
  }

  connectedCallback() {
    this.cacheElements();
    this.attachEventListeners();
  }

  disconnectedCallback() {
    this.detachEventListeners();
  }

  cacheElements() {
    this.gridOuter = this.querySelector('.grid-outer');
  }

  attachEventListeners() {
    window.addEventListener('scroll', this.debounce(this.bindHandleScroll, 300));
  }

  detachEventListeners() {
    window.removeEventListener('scroll', this.bindHandleScroll);
  }

  loadMoreProducts() {
    if (this.loading) return;

    const loadMoreBtn = this.querySelector('#load-more');
    if (!loadMoreBtn) return;

    const productGrid = this.querySelector('#CollectionLoop');

    const nextPageUrl = loadMoreBtn.getAttribute('href');
    if (!nextPageUrl || nextPageUrl === '') return;

    this.toggleLoadingState(true);

    fetch(nextPageUrl)
      .then(response => response.text())
      .then(data => {
        const parser = new DOMParser();
        const htmlDocument = parser.parseFromString(data, 'text/html');
        const newProducts = htmlDocument.querySelectorAll('#CollectionLoop .grid-item');
        const nextLoadMoreBtn = htmlDocument.querySelector('#load-more');

        // Append new products to the grid
        newProducts.forEach(product => {
          productGrid.appendChild(product);
        });

        // Update the "load-more" button for the next page
        if (nextLoadMoreBtn) {
          loadMoreBtn.setAttribute('href', nextLoadMoreBtn.getAttribute('href'));
        } else {
          loadMoreBtn.remove(); // No more pages
        }
        
        this.toggleLoadingState(false);
      })
      .catch(error => {
        console.error('Error loading products:', error);
        this.toggleLoadingState(false);
      });
  }

  handleScroll() {
    if (this.loading) return;

    const loadMoreBtn = this.querySelector('#load-more');
    if (!loadMoreBtn) return;
  
    const rect = loadMoreBtn.getBoundingClientRect();
    if (rect.top <= window.innerHeight) {
      this.loadMoreProducts();
    }
  }

  toggleLoadingState(loading) {
    this.loading = loading;
    if (!this.gridOuter) return;

    if (loading) {
      this.gridOuter.classList.add('is-loading');
    } else {
      this.gridOuter.classList.remove('is-loading');
    }
  }

  debounce(func, delay) {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func.apply(this, args), delay);
    };
  };
}

if (!customElements.get('product-grid')) {
  customElements.define('product-grid', ProductGrid);
}